import { Directive, ElementRef, Input, OnInit, OnDestroy } from '@angular/core';

@Directive({
  selector: '[CountTo]',
  standalone: false,
})
export class CountToDirective implements OnInit, OnDestroy {
  @Input() CountTo: number = 0;
  @Input() from: number = 0;
  @Input() duration: number = 2;
  @Input() delay: number = 0;

  private element: HTMLElement;
  private animationId: number;

  constructor(private el: ElementRef) {
    this.element = el.nativeElement;
  }

  ngOnInit() {
    setTimeout(() => {
      this.animateCount();
    }, this.delay * 1000);
  }

  ngOnDestroy() {
    if (this.animationId) {
      cancelAnimationFrame(this.animationId);
    }
  }

  private animateCount() {
    const start = this.from;
    const end = this.CountTo;
    const duration = this.duration * 1000; // Convert to milliseconds
    const startTime = performance.now();

    const animate = (currentTime: number) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);

      // Easing function for smooth animation
      const easeOutQuart = 1 - Math.pow(1 - progress, 4);
      const currentValue = Math.floor(start + (end - start) * easeOutQuart);

      this.element.textContent = currentValue.toString();

      if (progress < 1) {
        this.animationId = requestAnimationFrame(animate);
      }
    };

    this.animationId = requestAnimationFrame(animate);
  }
} 